import { memo } from 'react'

import { Warning } from '@mui/icons-material'
import { Alert, Badge, Box, List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material'
import { SmepEvent } from '@nativewaves/nw-cloud-sdk/smep'
import { useTranslation } from 'react-i18next'
import SimpleBar from 'simplebar-react'

import { getAlertSeverityColor } from 'utils'

type EventAlertsProps = {
  eventAlerts: SmepEvent['alerts']
}

const EventAlertsRaw = ({ eventAlerts }: EventAlertsProps) => {
  const { t } = useTranslation(['domain'])

  return (
    <Paper
      sx={{
        flex: 2,
        minWidth: 320,
        px: 4,
        py: 3,
      }}
      elevation={2}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fonWeight: 500, mb: 1 }} variant="heading-md">
          {t('Workspace.Event.alerts')}
        </Typography>
        {eventAlerts && !!eventAlerts.length && (
          <Badge
            sx={{
              '& .MuiBadge-badge': {
                right: -2,
                top: 0,
                border: (theme) => `2px solid ${theme.palette.background.paper}`,
                p: 0.5,
              },
            }}
            badgeContent={eventAlerts?.length}
            color="error"
          >
            <Warning color="error" />
          </Badge>
        )}
      </Box>

      {eventAlerts ? (
        eventAlerts.length ? (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <SimpleBar style={{ flex: 1, maxHeight: 200 }}>
              <List sx={{ width: '100%' }}>
                {eventAlerts.map((alert) => (
                  <ListItem key={alert.code}>
                    <ListItemIcon>
                      <Warning sx={{ color: getAlertSeverityColor(alert.severity)[500] }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={alert.name}
                      secondary={alert.details}
                      secondaryTypographyProps={{ noWrap: true }}
                    />
                  </ListItem>
                ))}
              </List>
            </SimpleBar>
          </Box>
        ) : (
          <Alert severity="success">{t('Workspace.Event.everythingIsFine')}</Alert>
        )
      ) : (
        <Alert severity="info">{t('Workspace.Event.eventAlertsNotLoaded')}</Alert>
      )}
    </Paper>
  )
}

export const EventAlerts = memo(EventAlertsRaw)
